import { Menu, useSidebarState } from 'react-admin'
import { Box, Typography, Divider, Tooltip, IconButton } from '@mui/material'
import { Business, Map, PhotoLibrary, FormatListBulleted } from '@mui/icons-material'
import { InvestmentSelector } from './InvestmentSelector'
import { useInvestmentContext } from '../contexts/InvestmentContext'

export const CustomMenu = (props: any) => {
  const [open] = useSidebarState()
  const { currentInvestment, userInvestments } = useInvestmentContext()

  // Moduł jest per-tenant, ale user może mieć wielu tenantów — pokaż gdy KTÓRYKOLWIEK
  // z jego tenantów ma flagę (lista agreguje inwestycje wszystkich flagowanych tenantów).
  const hasInvestmentListModule = userInvestments.some(
    inv => inv.tenant?.has_module_investment_list,
  )
  
  return (
    <div>
      <Box p={open ? 2 : 1}>
        {open ? (
          <>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Wybierz inwestycję
            </Typography>
            <InvestmentSelector />
          </>
        ) : (
          <Tooltip title={currentInvestment?.panel_display_label || currentInvestment?.name || 'Wybierz inwestycję'} placement="right">
            <IconButton size="small" color="primary">
              <Business />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      <Divider />
      <Menu {...props}>
        <Menu.ResourceItem name="properties" />
        {hasInvestmentListModule && (
          <Menu.Item to="/inwestycje" primaryText="Strona www" leftIcon={<FormatListBulleted />} />
        )}
        <Menu.Item to="/dane-inwestycji" primaryText="Dane inwestycji" leftIcon={<Map />} />
        <Menu.Item to="/zdjecia" primaryText="Zdjęcia" leftIcon={<PhotoLibrary />} />
      </Menu>
    </div>
  )
}